import isPlaceEqual from 'commons/js/util/isPlaceEqual'

export default function isSearchEqual ({place}, {place: otherPlace}) {
    return isPlaceEqual(place, otherPlace)
}
